/* KOLDER – Volume pricing vía variantes (forzado en Add-to-Cart) + anti-overwrite + compare-at */
(function(){
  if (window.__VPM_BOUND__) return;
  window.__VPM_BOUND__ = true;

  const $  = (s, r=document) => r.querySelector(s);
  const $$ = (s, r=document) => Array.from(r.querySelectorAll(s));
  const clamp = v => Math.max(1, parseInt(v || '1', 10));
  window.__kolder_formatCLP = formatCLP;
  window.__kolder_normalizeToPesos = normalizeToPesos;

  // -------- Utilidades --------
  function formatCLP(n){
    try{
      return new Intl.NumberFormat('es-CL',{style:'currency',currency:'CLP',minimumFractionDigits:0})
        .format(n).replace('CLP','$');
    }catch(e){ return '$' + (Math.round(n)).toString(); }
  }

  // Normaliza un precio que puede venir en pesos o centavos → siempre en PESOS
  function normalizeToPesos(p){
    let n = Number(p);
    if (!Number.isFinite(n)) return NaN;
    // Si es muy grande (>= 100.000) asumimos centavos → pásalo a pesos
    if (n >= 100000) n = n / 100;
    return n;
  }

  // -------- Config --------
  function readConfig(){
    const node = document.querySelector('script[data-price-tiers]');
    if(!node) return null;
    try { return JSON.parse(node.textContent || '{}'); } catch(e){ return null; }
  }

  function tierForQty(cfg, qty){
    if(!cfg || !Array.isArray(cfg.priceTiers)) return null;
    const tiers = [...cfg.priceTiers]
      .map(t => ({
        qty: +t.qty,
        variant_id: String(t.variant_id),
        // NORMALIZADO: unit_price en PESOS (si venía en centavos lo dividimos por 100)
        unit_price: normalizeToPesos(t.unit_price ?? t.price_cents ?? t.price)
      }))
      .filter(t => Number.isFinite(t.qty) && t.variant_id && Number.isFinite(t.unit_price))
      .sort((a,b)=>a.qty-b.qty);

    let chosen = tiers[0] || null;
    for (const t of tiers){ if(qty >= t.qty) chosen = t; else break; }
    return chosen;
  }

  // -------- UI precio --------
  let __painting = false;          // evita loop del observer
  let __currentPricePesos = null;  // última cifra correcta que debemos mantener
  let __basePricePesos = null;     // precio base (qty mínima) para tachado

  function ensureCompareNode(priceEl){
    let cmp = priceEl.querySelector('.kolder-compare');
    if (!cmp){
      cmp = document.createElement('span');
      cmp.className = 'kolder-compare';
      // estilo discreto y consistente con temas típicos
      cmp.style.cssText = 'display:block;font-size:20px;color:#999;text-decoration:line-through;font-weight:400;margin-bottom:4px;';
      // insertarlo al inicio del contenedor de precio
      priceEl.insertBefore(cmp, priceEl.firstChild);
    }
    return cmp;
  }

  function hideCompare(priceEl){
    const cmp = priceEl.querySelector('.kolder-compare');
    if (cmp) cmp.style.display = 'none';
  }

  function showCompare(priceEl, value){
    const cmp = ensureCompareNode(priceEl);
    cmp.textContent = formatCLP(value);
    cmp.style.display = 'block';
  }

  function paintPrice(unit){
    if (!Number.isFinite(unit)) return;
    __currentPricePesos = unit;

    const priceEl =
      document.querySelector('.product-form__info-item .product-form__info-content .price-list .price--highlight') ||
      document.querySelector('.product-form__info-item .product-form__info-content .price-list .price') ||
      document.querySelector('.price--highlight') ||
      document.querySelector('.price');

    if (!priceEl) return;

    const formatted = formatCLP(unit);

    // Compare-at (tachado) si hay base y el unit es menor
    if (Number.isFinite(__basePricePesos) && unit < __basePricePesos) {
      showCompare(priceEl, __basePricePesos);
    } else {
      hideCompare(priceEl);
    }

    // No toques /unidad ni spans auxiliares; intenta data-price-amount si existe
    const amountEl = priceEl.querySelector('[data-price-amount]');
    __painting = true;
    if (amountEl) {
      amountEl.textContent = formatted;
    } else {
      // Actualiza solo textnodes con números; evita tocar nuestro compare
      let updated = false;
      for (const node of Array.from(priceEl.childNodes)) {
        if (node.nodeType === Node.TEXT_NODE) {
          const txt = node.textContent.trim();
          if (txt && /[$\d]/.test(txt)) {
            node.textContent = formatted;
            updated = true;
            break;
          }
        }
      }
      if (!updated) {
        const walker = document.createTreeWalker(priceEl, NodeFilter.SHOW_TEXT);
        let n;
        while ((n = walker.nextNode())) {
          const parent = n.parentElement;
          if (
            parent &&
            !parent.classList.contains('visually-hidden') &&
            !parent.classList.contains('price__unit') &&
            !parent.classList.contains('price-unit') &&
            !parent.classList.contains('kolder-compare') // ⟵ no sobrescribir el tachado
          ) {
            const txt = n.textContent;
            if (txt && /[$\d]/.test(txt)) {
              n.textContent = formatted;
              break;
            }
          }
        }
      }
    }
    // libera el guard en el siguiente tick para que el observer vuelva a escuchar
    setTimeout(()=>{ __painting = false; }, 0);
  }

  // Observa si el tema sobreescribe el precio; si lo hace, lo reponemos
  function attachPriceObserver(){
    const container =
      document.querySelector('.product-form__info-item .product-form__info-content .price-list') ||
      document.querySelector('.price-list');
    if (!container) return;

    const obs = new MutationObserver(() => {
      if (__painting) return; // cambio causado por nosotros
      if (!Number.isFinite(__currentPricePesos)) return; // no tenemos referencia válida aún
      // Si el tema cambió el precio, repíntalo con nuestra cifra normalizada
      paintPrice(__currentPricePesos);
    });

    obs.observe(container, { subtree:true, childList:true, characterData:true });
  }

  // -------- Qty bindings (sin saltos extra) --------
  function syncQty(v){ $$('.quantity-selector__value').forEach(i=>{ if(parseInt(i.value,10)!==v) i.value=v; }); }
  function bindQty(onChange){
    $$('.quantity-selector__value').forEach(inp=>{
      const h = (e)=>{ const v = clamp(e.target.value); e.target.value=v; syncQty(v); onChange(v); };
      inp.addEventListener('input', h);
      inp.addEventListener('change', h);
    });
    const onPlusMinus = (ev)=>{
      const btn = ev.target.closest('[data-action="decrease-picker-quantity"],[data-action="increase-picker-quantity"]');
      if(!btn) return;
      ev.preventDefault(); ev.stopPropagation(); if(ev.stopImmediatePropagation) ev.stopImmediatePropagation();
      const picker = btn.closest('.quantity-selector');
      const inp = picker && picker.querySelector('.quantity-selector__value');
      if(!inp) return;
      const inc = btn.getAttribute('data-action')==='increase-picker-quantity' ? 1 : -1;
      const next = clamp((parseInt(inp.value||'1',10)||1) + inc);
      inp.value = next; syncQty(next);
      inp.dispatchEvent(new Event('change', { bubbles:true }));
      onChange(next);
    };
    document.addEventListener('click', onPlusMinus, true);
    document.addEventListener('touchstart', onPlusMinus, { passive:false, capture:true });
  }

  // -------- Add to cart forzado con variant del escalón --------
  function bindAddToCart(getState){
    document.addEventListener('click', async (e)=>{
      const addBtn = e.target.closest('button[name="add"], [data-add-to-cart], .product-form__add-button');
      if(!addBtn) return;

      const form = addBtn.closest('form');
      if (!form || !form.classList || !form.classList.contains('product-form')) return;

      e.preventDefault();
      const { cfg, qty } = getState();
      const tier = tierForQty(cfg, qty) || {};
      const variantId = tier.variant_id;
      const quantity  = qty;

      if(!variantId){ console.warn('Sin variant_id para el escalón'); return; }

      const prevText = addBtn.textContent;
      addBtn.disabled = true;
      addBtn.textContent = 'Agregando…';

      try{
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: variantId, quantity }] })
        });
        if (!res.ok) throw new Error('HTTP '+res.status);

        document.dispatchEvent(new CustomEvent('cart:updated'));
        document.dispatchEvent(new CustomEvent('cart:refresh'));

        if (window.theme && window.theme.cart && typeof window.theme.cart.open === 'function') {
          window.theme.cart.open();
        } else if (window.CartDrawer && typeof window.CartDrawer.open === 'function') {
          window.CartDrawer.open();
        } else {
          window.location.href = '/cart';
        }
      } catch(err){
        console.error('Error add.js', err);
        window.location.href = `/cart/add?id=${encodeURIComponent(variantId)}&quantity=${encodeURIComponent(quantity)}`;
      } finally {
        addBtn.disabled = false;
        addBtn.textContent = prevText;
      }
    }, true);
  }

  // -------- Init --------
  let cfg = null, qty = 1;

  function onQtyChange(v){
    qty = v;
    const t = tierForQty(cfg, qty);
    if (t) paintPrice(t.unit_price);
  }

  function init(){
    cfg = readConfig();
    const first = $('.quantity-selector__value');
    qty = clamp(first ? first.value : 1);

    // Calcula precio base (primer tramo por qty más baja)
    if (cfg && Array.isArray(cfg.priceTiers) && cfg.priceTiers.length){
      const sorted = [...cfg.priceTiers]
        .map(t => ({ qty:+t.qty, unit: normalizeToPesos(t.unit_price ?? t.price_cents ?? t.price) }))
        .filter(t => Number.isFinite(t.qty) && Number.isFinite(t.unit))
        .sort((a,b)=>a.qty-b.qty);
      __basePricePesos = sorted.length ? sorted[0].unit : null;
    } else {
      __basePricePesos = null;
    }

    // Observador de precio (evita que otro script lo “infle”)
    attachPriceObserver();

    const t0 = tierForQty(cfg, qty);
    if (t0) paintPrice(t0.unit_price);

    bindQty(onQtyChange);
    bindAddToCart(()=>({ cfg, qty }));
  }

  if (document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', ()=> setTimeout(init, 200));
  } else {
    setTimeout(init, 200);
  }
})();
/* ===== TIER SELECTOR BUTTONS ===== */
(function(){
  if (!document.querySelector('[data-tier-buttons], [data-tier-buttons-mobile]')) return;
  if (window.__TIER_BUTTONS_BOUND__) return;
  window.__TIER_BUTTONS_BOUND__ = true;

  // Reutiliza las funciones ya declaradas arriba en el scope global del archivo
  // Si por algún motivo no están disponibles, las define como fallback
  const formatCLP = window.__kolder_formatCLP || function(n){
    try{
      return new Intl.NumberFormat('es-CL',{style:'currency',currency:'CLP',minimumFractionDigits:0})
        .format(n).replace('CLP','$');
    }catch(e){ return '$' + Math.round(n); }
  };

  const normalizeToPesos = window.__kolder_normalizeToPesos || function(p){
    let n = Number(p);
    if (!Number.isFinite(n)) return NaN;
    if (n >= 100000) n = n / 100;
    return n;
  };

  function readTiers(){
    const node = document.querySelector('script[data-price-tiers]');
    if (!node) return [];
    try {
      const cfg = JSON.parse(node.textContent || '{}');
      return (cfg.priceTiers || [])
        .map(t => ({
          qty: +t.qty,
          unit_price: normalizeToPesos(t.unit_price ?? t.price_cents ?? t.price)
        }))
        .filter(t => Number.isFinite(t.qty) && Number.isFinite(t.unit_price))
        .sort((a,b) => a.qty - b.qty);
    } catch { return []; }
  }

  function getQtyInput(){
    return document.querySelector('.quantity-selector__value, input[name="quantity"]');
  }

  function getCurrentQty(){
    const inp = getQtyInput();
    return Math.max(1, parseInt(inp?.value || '1', 10));
  }

  function setQty(qty){
    const inp = getQtyInput();
    if (inp) {
      inp.value = qty;
      inp.dispatchEvent(new Event('input', { bubbles: true }));
      inp.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  function findTierForQty(tiers, qty){
    let chosen = tiers[0] || null;
    for (const t of tiers) {
      if (qty >= t.qty) chosen = t;
      else break;
    }
    return chosen;
  }

function renderButtons(){
  const containers = document.querySelectorAll('[data-tier-buttons], [data-tier-buttons-mobile]');
  if (containers.length === 0) return;

  const tiers = readTiers();
  
  if (tiers.length === 0) {
    // Ocultar TODO el selector agregando clase
    containers.forEach(c => {
      const tierSelector = c.closest('.price-tier-selector');
      if (tierSelector) tierSelector.classList.add('tier-selector--hidden');
    });
    return;
  }

  // Si hay tiers, asegurar que el selector sea visible
  containers.forEach(c => {
    const tierSelector = c.closest('.price-tier-selector');
    if (tierSelector) tierSelector.classList.remove('tier-selector--hidden');
  });

  containers.forEach(container => {
    container.innerHTML = '';
    
    tiers.forEach(tier => {
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'tier-button';
      btn.setAttribute('data-qty', tier.qty);
      btn.innerHTML = `
        <span class="tier-button__label">${tier.qty}</span>
        <span class="tier-button__price">${formatCLP(tier.unit_price)}</span>
      `;
      
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        setQty(tier.qty);
        document.dispatchEvent(new CustomEvent('kolder:tier-quantity-selected', {
          detail: {
            productId: readProductId(),
            quantity: tier.qty,
            unitPrice: tier.unit_price
          }
        }));
        updateActive();
      });
      
      container.appendChild(btn);
    });
  });

  updateActive();
}

function readProductId(){
  const node = document.querySelector('script[data-price-tiers]');
  if (!node) return '';
  try { return JSON.parse(node.textContent || '{}').productId || ''; }
  catch { return ''; }
}

function updateActive(){
  const tiers = readTiers();
  if (tiers.length === 0) return;

  const currentQty = getCurrentQty();
  const currentTier = findTierForQty(tiers, currentQty);
  
  document.querySelectorAll('[data-tier-buttons] .tier-button, [data-tier-buttons-mobile] .tier-button').forEach(btn => {
    const btnQty = parseInt(btn.getAttribute('data-qty'), 10);
    if (currentTier && btnQty === currentTier.qty) {
      btn.classList.add('is-active');
    } else {
      btn.classList.remove('is-active');
    }
  });
}

  document.addEventListener('input', (e) => {
    if (e.target.matches('.quantity-selector__value, input[name="quantity"]')) {
      setTimeout(updateActive, 50);
    }
  });

  document.addEventListener('change', (e) => {
    if (e.target.matches('.quantity-selector__value, input[name="quantity"]')) {
      updateActive();
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => setTimeout(renderButtons, 300));
  } else {
    setTimeout(renderButtons, 300);
  }
})();
